import React from 'react';
import { AvCheckbox } from '@fabric-ui/components';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { AvalorTableIds, generateInnerDefaultFormatter, loadingPercentages } from '../Table';
import { useAvTableV2Context } from './AvTableV2Provider';
import { TableSizeEnum } from './table.types';

interface IAvTableV2Loading {
  multiSelect?: boolean;
  totalRows?: number;
  pageSize: number;
  size: TableSizeEnum;
}

const AvTableV2Loading = ({ multiSelect, totalRows, pageSize, size }: IAvTableV2Loading) => {
  const table = useAvTableV2Context();
  const skeletonRowCount = totalRows && totalRows > 0 ? Math.min(totalRows, pageSize) : 3;
  const columns = table
    .getFlatHeaders()
    .filter(column => !([AvalorTableIds.InlineActionsId, AvalorTableIds.ExpandCaretId] as string[]).includes(column.id));

  return (
    <TableBody>
      {[...Array(skeletonRowCount)].map((_, index) => (
        <TableRow key={index} tabIndex={-1}>
          {multiSelect && (
            <TableCell padding="checkbox">
              <AvCheckbox disabled />
            </TableCell>
          )}
          {columns.map(column => (
            <TableCell key={column.id}>
              {generateInnerDefaultFormatter({
                value: loadingPercentages[index % 2],
                type: 'loading',
                size,
                shouldDisplayNull: table.options.meta?.shouldDisplayNull,
              })}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default AvTableV2Loading;
